module.exports = __webpack_public_path__ + "static/media/onboarding-1.4926dfe4.png";